module.exports = ".boolean-component .roundButton {\n  background: #ffffff;\n  color: #000000;\n  font-size: 14px;\n  vertical-align: top;\n  border-color: #ffffff;\n  padding-left: 4px;\n  padding-right: 4px;\n  width: 100%;\n  border: none;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/components/boolean/boolean.component.css
// module id = ./src/app/admin/components/boolean/boolean.component.css
// module chunks = main